$(function() {
	$(".link-grid.with-images.autosized").each(function() {
		$(this).find(".image").each(function() {
			var $th = $(this);
			if (!$th.is("img") && $th.find("img").length > 0) {
				$th = $th.find("img");
			}
			$th.closest("a").css("background-image", "url('"+$th.attr("src")+"')").addClass("processed-background");
			$th.css("opacity", "0.01");
		});
	});
});